module.exports = __webpack_public_path__ + "img/horkleya.2893ddcf.jpg";